import React from 'react'
import Header from './components/Header/Header'
import Display from './components/Display/Display'
import Footer from './components/Footer/Footer'

export const ErrorPage = () => {
  return (
    <div>
      <Header />
      <Display />
      <Footer />
    </div>
  )
}
